import { useCallback, useContext } from 'react';
import type { AxiosError } from 'axios';
import { useFetchChatInstanceMutation } from '@trinity/chat-components/api/hooks';
import { useScrollToBottomOfMessages } from '@trinity/chat-components/components/Chat/hooks/useScrollMessageList';
import { ChatStateDispatchContext } from '@trinity/chat-components/components/Chat.State/context';
import { ActiveBrandContext, SetActiveBrandContext } from '@trinity/chat-components/containers/UserBrands/UserBrandsContext';

type Props = {
  onError?: () => void;
  onSuccess?: () => void;
};

export const useLoadChatInstance = ({ onError, onSuccess }: Props = {}) => {

  const dispatch = useContext(ChatStateDispatchContext);
  const scrollToBottom = useScrollToBottomOfMessages();
  const setUserBrand = useContext(SetActiveBrandContext);
  const activeBrandIdentifier = useContext(ActiveBrandContext);
  const mutation = useFetchChatInstanceMutation();

  return useCallback((chatInstanceIdentifier: string) => {
    dispatch({
      type: 'session-loading',
      payload: { chatInstanceIdentifier },
    });
    mutation.mutateAsync({ chatInstanceIdentifier }, {
      onSuccess: res => {

        if (activeBrandIdentifier !== res.chatInstance.brandIdentifier) {
          dispatch({
            type: 'reset-chat-state',
            payload: {
              context: res.chatInstance.context,
              brandIdentifier: res.chatInstance.brandIdentifier,
            },
          });
          setUserBrand(res.chatInstance.brandIdentifier);
        }
        dispatch({
          type: 'batch-actions',
          payload: {
            actions: [
              { type: 'chat-loaded', payload: res },
              { type: 'session-loaded', payload: { chatInstanceIdentifier } },
            ],
          },
        });
        onSuccess?.();
        scrollToBottom({
          nthFromBottom: Object.keys(res.queries).length > 0 ? undefined : 1,
        });
      },
    })
      .catch((error: AxiosError) => {
        onError?.();
        // Toast.error({
        //   title: `Insights Chat`,
        //   body: `Could not find this chat thread!`,
        // });
      });
  }, [dispatch, mutation, activeBrandIdentifier, onSuccess, scrollToBottom, setUserBrand, onError]);
};